import { client } from './client'

export function resetDatabase() {
  return client('admin/db_reset', false, { method: 'POST' })
}
